// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const initializeFirebase = () => {
const firebaseConfig = {
    apiKey: "AIzaSyB0sKIFJzu46RiTaBBZcVDlfcSlIubWM3E",
    authDomain: "chineh-18a49.firebaseapp.com",
    projectId: "chineh-18a49",
    storageBucket: "chineh-18a49.appspot.com",
    messagingSenderId: "405348981391",
    appId: "1:405348981391:web:121d069c81426e16c4eefa",
    measurementId: "G-FVKXEVNWQ8"
};

// Initialize Firebase
const apps = initializeApp(firebaseConfig);
const analytics = getAnalytics(apps);
};
